import { create } from 'zustand';
import { useCases } from '../../infrastructure/di/container';
import { CurrentUserEntity } from '../../domain/entities/CurrentUser';

interface CurrentUserState {
  user?: CurrentUserEntity;
  loadedFor?: string;
  isLoading: boolean;
  error?: string;
  load: (firebaseUid: string) => Promise<void>;
  reset: () => void;
}

export const useCurrentUserStore = create<CurrentUserState>((set, get) => ({
  isLoading: false,
  async load(firebaseUid) {
    const { loadedFor, isLoading } = get();
    if (loadedFor === firebaseUid || isLoading) return;
    set({ isLoading: true, error: undefined, user: undefined });
    try {
      const user = await useCases.getCurrentUser().execute();
      set({ user, loadedFor: firebaseUid, isLoading: false });
    } catch (e: any) {
      set({ isLoading: false, loadedFor: firebaseUid, error: e?.message || 'Failed to load current user' });
    }
  },
  reset() {
    set({ user: undefined, loadedFor: undefined, isLoading: false, error: undefined });
  },
}));
